import { CasinoBonusMarksEnum } from '../constants';

import { Nullable } from 'v2/types/index';

export enum PromoPackTypeEnum {
  STANDARD = 'STANDARD',
  CUSTOM = 'CUSTOM',
}

export interface CasinoBenefitsData {
  promoPackType: PromoPackTypeEnum;
  freeSpinsCount: number | null;
  depositPercentage: number | null;
  customPromo: string | null;
}

export interface CasinoModel {
  id: string;
  name: string;
  shortPromoText: string;
  fullPromoText: string;
  solidLogoId: string;
  transparentLogoId: string;
  promoCode: string;
  marks: CasinoBonusMarksEnum[];
  benefits: CasinoBenefitsData;
  ymId: string;
  link: string;
  order: number;
  isActive: boolean;
  winNotificationText: string;
  logoVerticalId: Nullable<string>;
  logoSquareId: Nullable<string>;
}

export interface CasinoBonusModel {
  id: string;
  description: string;
  isDeposit: boolean;
  isRegistration: boolean;
  isNew: boolean;
  casinoId: string;
  promoCode: string;
  order: number;
  isActive: boolean;
  freeSpinsCount?: number;
  percentsToDeposit?: number;
}
